import { render } from "./np-pagination.vue?vue&type=template&id=80bfe438"
import script from "./np-pagination.vue?vue&type=script&lang=js"
export * from "./np-pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__